import React from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";

export default function DeleteOfferModal({ open, onClose, onConfirm }) {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-[300]">
      <DialogBackdrop className="fixed inset-0 bg-black/40" />
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        <DialogPanel className="w-full max-w-md bg-white rounded-lg shadow-xl">
          <div className="p-6">
            <DialogTitle className="text-lg font-bold mb-2">
              Delete Offer?
            </DialogTitle>
            <p className="text-sm text-gray-600">
              Are you sure you want to delete this offer?
            </p>
          </div>

          <div className="px-6 py-4 bg-gray-50 flex justify-end gap-3">
            <button className="px-4 py-2 border rounded" onClick={onClose}>
              Cancel
            </button>
            <button
              className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
              onClick={onConfirm}
            >
              Delete
            </button>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
